// i18next-extract-mark-ns-start homepage
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from '../../services/link';
import withAppContext from '../../withAppContext';
import { colors, tabletThresholdPixels } from './v4/styledComponents';

const BannerContainer = styled.div`
  width: 100%;
  padding: 18px 0px;
  background-color: ${colors.yellow900};
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
  }
`;

const P = styled.p`
  color: ${colors.black};
  font-size: 20px;
  text-align: center;
  margin: 0;
  padding: 0px 12px;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 14px;
  }
`;

const LinkSpan = styled.span`
  text-decoration: underline;
  color: ${colors.black};
`;

function RepairBonusBanner() {
  return (
    <BannerContainer>
      <P>
        Entre -6€ et -25€ d’aide sur le coût de votre réparation grâce au Bonus Réparation.
        {' '}
        <Link to="/bonus-reparation/">
          <LinkSpan>
            + d’infos
          </LinkSpan>
        </Link>
      </P>
    </BannerContainer>
  );
}

RepairBonusBanner.propTypes = {
  context: PropTypes.shape({
    isMobile: PropTypes.bool,
  }).isRequired,
};

export default withAppContext(RepairBonusBanner);
